import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, {
        color: "indigo",
        elevation: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, { class: "toolbar-title" }, {
            default: _withCtx(() => [
              _createTextVNode("Metrics Viewer")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, { class: "d-flex justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.navigateToCopilot,
            color: "blue",
            class: "metrics-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Copilot Metrics")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            onClick: _ctx.navigateToNCode,
            color: "green",
            class: "metrics-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("nCode Metrics")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}